import CompanyOverview from '~/components/admin/blocks/company-overview.vue'

export default defineNuxtPlugin({
	name: 'load-admin-components',
	parallel: true,
	async setup(nuxtApp) {
		nuxtApp.vueApp.component('CompanyOverview', CompanyOverview)
	}
})